import Api from '@/services/API'

export default {
  fetchCompetences () {
    return Api().get('/competences/')
  },
  addCompetence (params) {
    return Api().post('/competences/', params)
  },
  updateCompetence (params) {
    const token = params.token
    delete params.token
    return Api().put('/competences/' + params._id, params, { headers: {'Authorization': `${token}`} }).catch(function (error) {
      if (error.response) {
        // Request made and server responded
        if (error.response.status === 401) {
          alert('Unauthorized, check password.')
        } else if (error.response.status === 404) {
          alert('Entry not found.')
        }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request)
        alert(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
        alert(error.message)
      }
    })
  },
  getCompetence (params) {
    return Api().get('/competences/' + params.id)
  },
  deleteCompetence (params) {
    const token = params.token
    delete params.token
    return Api().delete('/competences/' + params.id, { headers: {'Authorization': `${token}`} }).catch(function (error) {
      if (error.response) {
        // Request made and server responded
        if (error.response.status === 401) {
          alert('Unauthorized, check password.')
        } else if (error.response.status === 404) {
          alert('Entry not found.')
        }
      } else if (error.request) {
        // The request was made but no response was received
        console.log(error.request)
        alert(error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
        alert(error.message)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/competencesService.js